import React, { Fragment, useEffect, useState } from 'react';
import {Routes, Route, Navigate, useLocation} from 'react-router-dom';
import { ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.js'
// Font Awesome
import './assets/plugins/fontawesome/css/fontawesome.min.css';
import './assets/plugins/fontawesome/css/all.min.css';
import 'remixicon/fonts/remixicon.css';
// Custom CSS
import './assets/css/style.css';
import './assets/css/custome.css';

//liste des pages
import { DefaultSpinner } from './components/ui/Spinner';
import useUserAuth from './components/backend/auth/RequireAuths'
import { expireSession, installSessionExpiryInterceptor, tokenExpirationTime } from './components/backend/auth/sessionExpiry';
import { useSelector } from 'react-redux';
import Header from './components/header/Header';
import HeaderAppHome from './components/header/HeaderAppHome';
import Footer from './components/footer/Footer';
import Accueil from './components/Accueil';
import Login from './components/accounts/Login';
import CheckUserMail from './components/accounts/CheckUserMail';
import FormSubmitResetPwd from './components/accounts/FormSubmitResetPwd';


//admin
import Apps from './components/backend';

import PrivateAdmin from './components/backend/in';

import UserSettings from './components/backend/home/user/UserSettings';

import Users from './components/backend/in/users';
import UpdateUserAccount from './components/backend/in/users/UpdateUserAccount';
import CreateUserAccount from './components/backend/in/users/CreateUserAccount';
import ServiceUnits from './components/backend/in/users/ServiceUnits';

import Apropos from './components/Apropos';
import Contacts from './components/Contacts';
import GuideDocs from './components/GuideDocs';
import PlanArchiveTabs from './components/backend/in/plan/PlanArchiveTabs';
import PlanClassementCreate from './components/backend/in/plan/PlanClassementCreate';
import ArchiveProfiles from './components/backend/in/archives/ArchiveProfiles';
import Archives from './components/backend/in/archives/Archives';
import ArchiveCreate from './components/backend/in/archives/ArchiveCreate';
import ArchiveDetails from './components/backend/in/archives/ArchiveDetails';
import ArchiveImport from './components/backend/in/archives/ArchiveImport';
import IncompleteImportTasks from './components/backend/in/archives/IncompleteImportTasks';
import MetadataQualityPage from './components/backend/in/archives/MetadataQualityPage';
import ArchiveLogs from './components/backend/in/archives/ArchiveLogs';
import IntegrityBaselinePage from './components/backend/in/archives/IntegrityBaselinePage';
import SearchArchiveItems from './components/backend/in/archives/SearchArchiveItems';
import GetProfileListe from './components/backend/in/archives/get_profile_liste';
import ReglesConservationList from './components/backend/in/archives/ReglesConservationList';
import RegleConservation from './components/backend/in/archives/RegleConservation';
import './assets/css/dataTables.css';


function App() {
    const { pathname } = useLocation();
    const token = useSelector((state) => state.sessionAuth.token);

    useEffect(() => installSessionExpiryInterceptor(), []);

    useEffect(() => {
        if (!token || token === 'expired') return undefined;
        const expiration = tokenExpirationTime(token);
        if (!expiration) return undefined;
        const remaining = expiration - Date.now();
        if (remaining <= 0) {
            expireSession();
            return undefined;
        }
        const timeout = setTimeout(expireSession, remaining);
        return () => clearTimeout(timeout);
    }, [token]);

    useEffect(() => {
        document.title = pathname === '/login'
            ? 'Connexion | SyiDocs Archivage'
            : 'SyiDocs Archivage';
    }, [pathname]);

    const [isLoading, setIsLoading] = useState(true)
    
    //phase de verification de la connexion
    const [authenticate, setAuthenticate] = useState(null)
    const isAuthenticated = useUserAuth();
    
    useEffect(()=>{
        setAuthenticate(isAuthenticated);
        if(authenticate !== null){
            setTimeout(()=>{
            setIsLoading(false)
        },[500])
            
    }
    return ()=> isAuthenticated
    
    },[isAuthenticated, authenticate])
   
  return !isLoading ? (
    
   <Fragment> 
    <div className='main-wrapper slide-nav'>
    {authenticate? <HeaderAppHome/> :  <Header/> }
    <Routes>
      <Route path='/' element={<Accueil/>} />
      <Route path='/accueil' element={<Accueil/>} />
      <Route path='/login' element={<Login/>} />
      <Route path='/mot-de-passe-oublie' element={<CheckUserMail/>} />
      <Route path='/reset-password/:sessionId/:resetToken' element={<FormSubmitResetPwd/>} />
      <Route path='/apropos' element={<Apropos/>} />
      <Route path='/guide-utilisateur' element={<GuideDocs/>} />
      <Route path='/plan-documentaire' element={<Navigate to='/guide-utilisateur' replace/>} />
      <Route path='/contacts' element={<Contacts/>} />
       

        {/**contenue protege */}
        <Route path='/apps' element={<Apps/>}> 
            {/**administration */}

            <Route path='in' element={<PrivateAdmin/>}> 
                <Route path='dashboard/:sessionId' element={<Archives/>}/>
                <Route path='users-accounts/page/:page' element={<Users/>}/>
                <Route path='users-accounts/create' element={<CreateUserAccount/>}/>
                <Route path='users/:id/:sessionId/:user' element={<UpdateUserAccount/>}/>
                <Route path='services-producteurs' element={<ServiceUnits/>}/>
    
                <Route path='plan-classement' element={<PlanArchiveTabs/>}/>
                <Route path='plan-classement/create' element={<PlanClassementCreate/>}/>
                <Route path='dossiers-archives' element={<PlanArchiveTabs/>}/>
                <Route path='archives/profils' element={<GetProfileListe/>}/>
                <Route path='archives/profils/add' element={<ArchiveProfiles/>}/>
                <Route path='archives/profils/:id' element={<ArchiveProfiles/>}/>
                <Route path='archives/regles-conservation' element={<ReglesConservationList/>}/>
                <Route path='archives/regles-conservation/add' element={<RegleConservation/>}/>
                <Route path='archives/regles-conservation/:id' element={<RegleConservation/>}/>
                <Route path='archives' element={<Archives/>}/>
                <Route path='archives/search' element={<SearchArchiveItems/>}/>
                <Route path='archives/qualite-metadonnees' element={<MetadataQualityPage/>}/>
                <Route path='archives/logs' element={<ArchiveLogs/>}/>
                <Route path='archives/integrite-regularisation' element={<IntegrityBaselinePage/>}/>
                <Route path='archives/detail/:uuid' element={<ArchiveDetails/>}/>
                <Route path='archives/add' element={<ArchiveCreate/>}/>
                <Route path='archives/import' element={<ArchiveImport/>}/>
                <Route path='archives/taches-incompletes' element={<IncompleteImportTasks/>}/>
            </Route> 

            {/**Fin pages administration */}

            <Route path='home' element={< Navigate to= '/' />}/>
            
            <Route path='home/user' element={<UserSettings/>}/> 
            <Route path='' element={< Navigate to= '/' />}/> 
        </Route>
        {/**Fin protect */}
      <Route path='*' element={ < Navigate to= '/' />}/>
    </Routes>
    <Footer/>
    </div>

    <ToastContainer />
   </Fragment>
  )
  :(DefaultSpinner(''))
  
}

export default App;
